module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table-view"
  }, [_c('table', {
    staticClass: "ui very basic table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      staticClass: "product-row"
    }, [_c('td', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-info"
    }, [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": product.largeImageUrl || '/placeholder.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "product-details"
    }, [_c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "product-title",
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_vm._v("\n                " + _vm._s(product.productTitle) + "\n              ")])])])]), _vm._v(" "), _c('td', {
      staticClass: "sales-cell"
    }, [_c('div', {
      staticClass: "sales-info"
    }, [_c('div', [_vm._v(_vm._s(_vm.salesCountTotal([product.productId], 'y')) + " units sold ystd.")]), _vm._v(" "), _c('div', {
      staticClass: "sales-today"
    }, [_vm._v(_vm._s(_vm.salesCountTotal([product.productId], 't')) + " so far today (" + _vm._s(product.marketplace.toUpperCase()) + ")")])])]), _vm._v(" "), _c('td', {
      staticClass: "cogs-cell"
    }, [(product.cogs && product.cogs > 0) ? _c('div', {
      staticClass: "cogs-value"
    }, [_vm._v("\n            $" + _vm._s(_vm.formatPrice(product.cogs)) + "\n          ")]) : _c('div', {
      staticClass: "cogs-empty"
    }, [_c('span', {
      staticClass: "empty-dash"
    }, [_vm._v("—")]), _vm._v(" "), _c('button', {
      staticClass: "add-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add")])])]), _vm._v(" "), _c('td', {
      staticClass: "margin-cell"
    }, [(product.cogs && product.cogs > 0 && product.buyBoxPrice) ? _c('span', {
      staticClass: "margin-value",
      class: _vm.getMarginClass(_vm.calculateMargin(product))
    }, [_vm._v("\n            " + _vm._s(_vm.calculateMargin(product)) + "%\n          ")]) : _c('span', {
      staticClass: "margin-empty"
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
      staticClass: "actions-cell"
    }, [_c('button', {
      staticClass: "ui icon button mini",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openChartModal(product)
        }
      }
    }, [_c('i', {
      staticClass: "chart bar icon"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v("\n      Showing " + _vm._s(_vm.startItem) + " - " + _vm._s(_vm.endItem) + " of " + _vm._s(_vm.totalItems) + " products\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((_vm.visiblePages), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page + 1) + "\n      ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "tableCogsModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Set COGS for Product")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Product")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cogsModalProduct ? _vm.cogsModalProduct.productTitle : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("COGS (Cost of Goods Sold) $")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cogsInput),
      expression: "cogsInput"
    }],
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "Enter COGS amount"
    },
    domProps: {
      "value": (_vm.cogsInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveCogs.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cogsInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.cogsInput && _vm.cogsModalProduct && _vm.cogsModalProduct.buyBoxPrice) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Preview")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("COGS:")]), _vm._v(" $" + _vm._s(_vm.formatPrice(parseFloat(_vm.cogsInput) || 0))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Box Price:")]), _vm._v(" $" + _vm._s(_vm.formatPrice(_vm.cogsModalProduct.buyBoxPrice))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Margin:")]), _vm._v(" " + _vm._s(_vm.calculateMarginFromCogs(parseFloat(_vm.cogsInput) || 0, _vm.cogsModalProduct.buyBoxPrice)) + "%\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui cancel button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.savingCogs
    },
    on: {
      "click": _vm.saveCogs
    }
  }, [_vm._v("\n        Save\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "product-column"
  }, [_vm._v("PRODUCT")]), _vm._v(" "), _c('th', {
    staticClass: "sales-column"
  }, [_vm._v("SALES")]), _vm._v(" "), _c('th', {
    staticClass: "cogs-column highlighted"
  }, [_vm._v("COGS")]), _vm._v(" "), _c('th', {
    staticClass: "margin-column highlighted"
  }, [_vm._v("MARGIN")]), _vm._v(" "), _c('th', {
    staticClass: "actions-column"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-199f9af3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductTableView.vue
// module id = 732
// module chunks = 2